/* eslint-disable dot-notation */
import type { App } from 'vue'
import LzNav from '@/components/nav/LzNav.vue'
import LzNavItem from '@/components/nav/LzNavItem.vue'
import LzProto from '@/components/LzProto.vue'
import LzAccordion from '@/components/base/LzAccordion.vue'
import LzIcon from '@/components/base/LzIcon.vue'
import LzAccordionManager from '@/components/base/LzAccordionManager.vue'
import LzNewsList from '@/components/news/LzNewsList.vue'
import LzExperts from './components/experts/LzExperts.vue'
import LzExpertsItem from './components/experts/LzExpertsItem.vue'
import LzVerticalAccordion from '@/components/base/LzVerticalAccordion.vue'
import LzShowMore from '@/components/base/LzShowMore.vue'

export default {
    install(app: App) {
        app.component('lz-proto', LzProto)
        app.component('lz-icon', LzIcon)
        app.component('lz-nav', LzNav)
        app.component('lz-nav-item', LzNavItem)
        app.component('lz-accordion-manager', LzAccordionManager)
        app.component('lz-accordion', LzAccordion)
        app.component('lz-news-list', LzNewsList)
        app.component('lz-experts', LzExperts)
        app.component('lz-experts-item', LzExpertsItem)
        app.component('lz-vertical-accordion', LzVerticalAccordion)
        app.component('lz-show-more', LzShowMore)
        /**
         * global properties
         */
        app.config.globalProperties.$contextPath = window['contextPath']
        // also provide them, so we can use them in composition api components with `inject`
        app.provide('contextPath', window['contextPath'])
    }
}
